const carConfigurationView = {
  templateUrl: '/modules/configurationManagement/car-configuration-view/car-configuration-view.html',
  controller: 'CarConfigurationViewController',
  bindings: {
    trainId: '<',
    consist: '<',
    carNumber: '<',
  }

};

angular
    .module('configuration-management.module')
    .component('carConfigurationView', carConfigurationView)
    .config(function ($stateProvider) {
        $stateProvider
            .state('car', {
                url: '/train/:trainId/car/:carNumber',
                redirectTo: 'car.details',
                component: 'carConfigurationView',
                resolve: {
                    auth: function (userService, $state, eventService) {
                        return userService
                            .resolve(['ACCESS_CAR_VIEW'])
                            .then(() => {
                            })
                            .catch(() => {
                                eventService.trigger('userservice:unauthorized');
                                $state.go('frontpage');
                            });
                    },
                }
            });
    });